import { Button } from "@features/atoms/Button"
import { Appear } from "@features/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Donate Right",
}

export default defineBlock("support/donate-right", (props) => {
  return (
    <Appear className={cn("donate-right w-full grid grid-cols-3 gap-2 py-5 pr-5")} delay={50}>
      <Button className="w-full justify-center border-white" variant="filled">
        $20
      </Button>
      <Button className="w-full justify-center border-white" variant="filled">
        $50
      </Button>
      <Button className="w-full justify-center border-white" variant="filled">
        $100
      </Button>
      <Button className="w-full col-span-3 justify-center border-white" variant="filled">
        OTHER
      </Button>
      <Button className="w-full col-span-3 mt-2 justify-center" variant="outline">
        DONATE
      </Button>
    </Appear>
  )
})
